var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/file-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 5 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33334 11.3337C5.33334 10.9655 5.63182 10.667 6.00001 10.667H10C10.3682 10.667 10.6667 10.9655 10.6667 11.3337C10.6667 11.7018 10.3682 12.0003 10 12.0003H6.00001C5.63182 12.0003 5.33334 11.7018 5.33334 11.3337Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33334 8.66667C5.33334 8.29848 5.63182 8 6.00001 8H10C10.3682 8 10.6667 8.29848 10.6667 8.66667C10.6667 9.03486 10.3682 9.33333 10 9.33333H6.00001C5.63182 9.33333 5.33334 9.03486 5.33334 8.66667Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5 (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33334 5.99967C5.33334 5.63148 5.63182 5.33301 6.00001 5.33301H6.66668C7.03487 5.33301 7.33334 5.63148 7.33334 5.99967C7.33334 6.36786 7.03487 6.66634 6.66668 6.66634H6.00001C5.63182 6.66634 5.33334 6.36786 5.33334 5.99967Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 14 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33332 2.66634C4.59694 2.66634 3.99999 3.26329 3.99999 3.99967V11.9997C3.99999 12.7361 4.59694 13.333 5.33332 13.333H10.6667C11.403 13.333 12 12.7361 12 11.9997V5.88529C12 5.70848 11.9298 5.53891 11.8047 5.41389L9.25244 2.8616C9.12742 2.73658 8.95785 2.66634 8.78104 2.66634H5.33332ZM2.66666 3.99967C2.66666 2.52692 3.86056 1.33301 5.33332 1.33301H8.78104C9.31147 1.33301 9.82018 1.54372 10.1953 1.91879L12.7475 4.47108C13.1226 4.84615 13.3333 5.35486 13.3333 5.88529V11.9997C13.3333 13.4724 12.1394 14.6663 10.6667 14.6663H5.33332C3.86056 14.6663 2.66666 13.4724 2.66666 11.9997V3.99967Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 15 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 2V3.33333C9.33333 4.4379 10.2288 5.33333 11.3333 5.33333H12.6667V6.66667H11.3333C9.49238 6.66667 8 5.17428 8 3.33333V2H9.33333Z",
    fill: "#667085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/NoteIcon.93dc7cacacde5683e1342ee676107db5.svg";
export { ForwardRef as ReactComponent };